<template>
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="full-height" style="padding: 20px; padding-bottom: 0; height: 100%">
    <el-tabs v-model="panel" @tab-click="handleClick">
      <el-tab-pane label="項目設定" name="item">
        <!-- <el-row v-if="panel == 'item'" class="row-box full-height">
          <div style="padding-bottom: 0">
            <el-form :inline="true">
              <el-form-item>
                <el-button
                  type="success"
                  @click="addData"
                  :disabled="listLoading"
                  >建立</el-button
                >
              </el-form-item>
            </el-form>
          </div>

          <div style="position: relative; height: 80%">
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="list"
              border
              fit
              highlight-current-row
              style="width: 100%"
              height="100%"
            >
              <el-table-column align="center" label="項次" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.row.id }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="標題" width="110">
                <template slot-scope="scope">
                  <span>{{ scope.row.title }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="排序" width="110">
                <template slot-scope="scope">
                  <span>{{ scope.row.sort }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="種類" width="300">
                <template slot-scope="scope">
                  <span>{{ changeShowType(scope.row.types) }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="編輯" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="editData(scope.row)"
                    >編輯</el-button
                  >
                </template>
              </el-table-column>

              <el-table-column label="刪除" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="handleDelete(scope)"
                    >刪除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-row> -->
      </el-tab-pane>
      <el-tab-pane label="分類設定" name="type">
        <!-- <el-row v-if="panel == 'type'" class="row-box full-height">
          <div style="padding-bottom: 0">
            <el-form :inline="true">
              <el-form-item>
                <el-button
                  type="success"
                  @click="addData"
                  :disabled="listLoading"
                  >建立</el-button
                >
              </el-form-item>
            </el-form>
          </div>

          <div>
            <el-table
              v-loading="listLoading"
              size="mini"
              :data="list"
              border
              fit
              highlight-current-row
              style="width: 100%"
              height="100%"
            >
              <el-table-column align="center" label="ID" width="60">
                <template slot-scope="scope">
                  <span>{{ scope.row.id }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="標題" width="110">
                <template slot-scope="scope">
                  <span>{{ scope.row.title }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="排序" width="110">
                <template slot-scope="scope">
                  <span>{{ scope.row.sort }}</span>
                </template>
              </el-table-column>

              <el-table-column align="center" label="編輯" width="100">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="primary"
                    @click="editData(scope.row)"
                    >編輯</el-button
                  >
                </template>
              </el-table-column>

              <el-table-column label="刪除" width="150" align="center">
                <template slot-scope="scope">
                  <el-button
                    type="danger"
                    size="mini"
                    @click="handleDelete(scope)"
                    >刪除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-row> -->
      </el-tab-pane>
    </el-tabs>

    <div style="padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="success" @click="addData" :disabled="listLoading">建立</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        size="mini"
        :data="list"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
      >
        <el-table-column align="center" label="ID" width="60">
          <template slot-scope="scope">
            <span>{{ scope.row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="標題" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="panel == 'item'" align="center" label="code" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.sort }}</span>
          </template>
        </el-table-column>

        <el-table-column v-if="panel == 'item'" align="center" label="種類" width="300">
          <template slot-scope="scope">
            <span>{{ changeShowType(scope.row.types) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editData(scope.row)">編輯</el-button>
          </template>
        </el-table-column>

        <el-table-column label="刪除" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="handleDelete(scope)">刪除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      @closed="onDialogClosed"
      :title="
        formData.id !== undefined && formData.id !== null ? '編輯【' + dialogTitle + '】' : '新增'
      "
      :visible.sync="dialogFormVisible"
      width="50%"
      top="1%"
      style="border: 2px solid #ccc"
    >
      <el-card class="box-card" v-loading="formLoading" :body-style="{ border: '1px solid #ccc' }">
        <el-row>
          <el-col>
            <el-form ref="dynamicValidateForm" :model="formData" :rules="rules">
              <el-form-item label="標題" :label-width="formLabelWidth" prop="title">
                <el-input v-model="formData.title" autocomplete="off" />
              </el-form-item>
              <el-form-item
                v-if="panel == 'item'"
                label="code"
                :label-width="formLabelWidth"
                prop="code"
              >
                <el-input v-model="formData.code" autocomplete="off" />
              </el-form-item>
              <el-form-item
                v-if="panel == 'item'"
                label="分類"
                :label-width="formLabelWidth"
                prop="types"
              >
                <el-select
                  v-model="formData.types"
                  multiple
                  collapse-tags
                  style="width: 100%"
                  placeholder="請選擇"
                  value-key="id"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.title"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="排序" :label-width="formLabelWidth" prop="sort">
                <el-input v-model="formData.sort" autocomplete="off" type="number" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-card>

      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveData('dynamicValidateForm')">儲 存</el-button>

        <el-button @click="dialogFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { Message } from 'element-ui'
import { deleteItem, deleteType, getItemOfType, getType, saveItem, saveType } from '@/api/tcSetting'
var defaultFormData = {
  id: null,
  types: [],
  sort: 99,
  title: '',
  code: '',
}

var defaultTypeFormData = {
  id: null,
  sort: 99,
  title: '',
}

export default {
  computed: {
    changeShowType() {
      return function (array) {
        return array
          .map(item => {
            return item.title
          })
          .toString()
      }
    },
  },
  data() {
    var validateNumber = (rule, value, callback) => {
      let re = new RegExp(/^\d+$/)
      if (!value || value === '') {
        callback(new Error('請輸入排序'))
      } else if (!re.test(value)) {
        callback(new Error('限輸入數字'))
      } else {
        callback()
      }
    }
    return {
      rules: {
        title: [{ required: true, message: '請輸入名稱', trigger: 'blur' }],
        code: [{ required: true, message: '請輸入code', trigger: 'blur' }],
        sort: [{ required: true, validator: validateNumber, trigger: 'blur' }],
        types: [
          { required: true, message: '請選擇分類', trigger: 'blur' },
          { type: 'array', message: '格式錯誤', trigger: 'blur' },
        ],
      },
      formLoading: false,
      formData: {},
      panel: 'item',
      listLoading: false,
      list: [],
      dialogFormVisible: false,
      formLabelWidth: '120px',
      options: [],
    }
  },
  async created() {
    await this.getTypeSelectList()
    await this.getList()
  },
  methods: {
    async handleClick(tab, event) {
      this.list = []
      if (tab.name == 'item') {
        await this.getTypeSelectList()
        await this.getList()
      } else {
        await this.getTypes()
      }
    },
    async getTypeSelectList() {
      await getType()
        .then(response => {
          this.options = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getList() {
      const vm = this
      vm.listLoading = true
      await getItemOfType().then(response => {
        this.list = response.data
        this.listLoading = false
      })
    },
    async getTypes() {
      const vm = this
      vm.listLoading = true
      await getType().then(response => {
        this.list = response.data
        this.listLoading = false
      })
    },
    addData() {
      let vm = this
      if (vm.panel == 'item') {
        vm.formData = JSON.parse(JSON.stringify(defaultFormData))
      } else {
        vm.formData = JSON.parse(JSON.stringify(defaultTypeFormData))
      }
      vm.dialogFormVisible = true
    },
    editData(d) {
      const vm = this
      //複製物件
      let jData = JSON.parse(JSON.stringify(d))
      vm.dialogTitle = d.title
      vm.formData = jData
      vm.dialogFormVisible = true
    },
    onDialogClosed() {
      this.$refs['dynamicValidateForm'].clearValidate()
    },
    async saveData(formName) {
      const vm = this
      console.log(vm.formData.title)
      if (!confirm(`確定要儲存資料?`)) {
        return false
      }

      this.$refs[formName].validate(async valid => {
        if (valid) {
          vm.formLoading = true

          if (this.panel == 'item') {
            await saveItem(vm.formData)
              .then(async response => {
                vm.formLoading = false
                vm.dialogFormVisible = false
              })
              .catch(error => {
                vm.formLoading = false
              })
            await this.getList()
          } else {
            await saveType(vm.formData)
              .then(async response => {
                vm.formLoading = false
                vm.dialogFormVisible = false
              })
              .catch(error => {
                vm.formLoading = false
              })
            await this.getTypes()
          }

          Message({
            message: '資料處理完成',
            type: 'success',
            duration: 5 * 1000,
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleDelete({ $index, row }) {
      console.log($index, row)

      this.$confirm('確定刪除該筆資料?', '警告', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.listLoading = true
          if (this.panel == 'item') {
            await deleteItem({ id: row.id })
            await this.getList()
          } else {
            await deleteType({ id: row.id })
            await this.getTypes()
          }

          this.$message({
            type: 'success',
            message: '刪除成功',
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
  },
}
</script>

<style>
.full-height {
  position: relative;
  height: 100%;
}
</style>

<style lang="scss" scoped>
.is-scrolling-none {
  height: 100% !important;
}
</style>
